import React from "react";

/**
 * The page-header convention, per SHELL.md:
 *
 *   `.page-head` = title (display 22) + one-line purpose subtitle +
 *   right-aligned primary actions.
 *
 * Defined once so every surface gets the same header rather than five sessions
 * each inventing one. `subtitle` is the *purpose* of the page in one line, not
 * a description of its contents — SHELL.md is specific about that, and it is
 * the difference between a header that orients and one that repeats the title.
 */
export default function PageHead({ title, subtitle, actions }) {
  return (
    <header className="page-head">
      <div className="page-head-text">
        <h1 className="display">{title}</h1>
        {subtitle ? <p className="page-head-sub dim">{subtitle}</p> : null}
      </div>
      {actions ? <div className="page-head-actions">{actions}</div> : null}
    </header>
  );
}

/**
 * A section block's mono label, per SHELL.md: "Section blocks use
 * `.section-title` (mono label)."
 */
export function SectionTitle({ children }) {
  return <div className="section-title">{children}</div>;
}
